var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#555"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.475 3.68a7.01 7.01 0 004.42 4.438 7.018 7.018 0 00-4.42 4.418 7.018 7.018 0 00-4.42-4.42 7.048 7.048 0 004.42-4.436zM10.28 13.985a5.73 5.73 0 00-3.23 3.23 5.73 5.73 0 00-3.229-3.23 5.722 5.722 0 003.23-3.242 5.723 5.723 0 003.229 3.242zM7.05 9.526a.205.205 0 00-.21.169l.46.178a5.282 5.282 0 01-.02-.089v-.002a5.411 5.411 0 01-.02-.087.205.205 0 00-.21-.169zM4.335 8.158a5.746 5.746 0 00-3.276-3.28 5.675 5.675 0 003.276-3.291 5.648 5.648 0 003.28 3.29 5.718 5.718 0 00-3.28 3.28z"
  }))));
}
export default __webpack_public_path__ + "static/media/magic_icon.32c66aac.svg";
export { SvgMagicIcon as ReactComponent };